import React from 'react';
import LibraryScreen from '../../src/screens/library/LibraryScreen';

export default function LibraryRoute() {
  return <LibraryScreen />;
}
